import { LANGUAGE_PARAM } from "@web/booking/constants";

export type BookingRoute =
  | { readonly kind: "book"; readonly slug: string }
  | { readonly kind: "manage"; readonly token: string; readonly slug: string | undefined }
  | { readonly kind: "unknown" };

export function parseRoute(pathname: string, search = ""): BookingRoute {
  const prefix = pathname.startsWith("/booking/manage/")
    ? "/booking/"
    : pathname.startsWith("/book/")
      ? "/book/"
      : undefined;

  if (!prefix) {
    return { kind: "unknown" };
  }

  const parts = pathname
    .slice(prefix.length)
    .split("/")
    .filter((part) => part !== "");

  if (parts[0] === "manage" && parts[1]) {
    return {
      kind: "manage",
      token: decodeURIComponent(parts[1]),
      slug: clinicSlugFor(decodeURIComponent(parts[1]), search),
    };
  }

  return parts[0] ? { kind: "book", slug: decodeURIComponent(parts[0]) } : { kind: "unknown" };
}

const STORAGE_PREFIX = "clinic.booking.";

function clinicSlugFor(token: string, search: string): string | undefined {
  const fromQuery = new URLSearchParams(search).get("clinic");

  if (fromQuery) {
    return fromQuery;
  }

  try {
    return window.localStorage.getItem(STORAGE_PREFIX + token) ?? undefined;
  } catch {
    return undefined;
  }
}

export function rememberClinic(token: string, slug: string): void {
  try {
    window.localStorage.setItem(STORAGE_PREFIX + token, slug);
  } catch {}
}

export function languageUrl(language: string, primaryLanguage: string): URL {
  const url = new URL(window.location.href);

  if (language === primaryLanguage) {
    url.searchParams.delete(LANGUAGE_PARAM);
  } else {
    url.searchParams.set(LANGUAGE_PARAM, language);
  }

  return url;
}
